import React, { Component } from 'react';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
// import TwitterLogin from 'react-twitter-auth';
// import { GoogleLogin } from 'react-google-login';
import config from '../config.json';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
    CNavbar, CNavLink, CNavbarNav, CNavbarBrand, CDropdownItem,
    CCollapse, CForm, CInput, CButton, CToggler, CDropdownToggle,
    CInputGroup, CInputGroupAppend, CInputGroupText, CDropdownMenu,
    CDropdown, CImage, CBadge,
} from 'compat/coreui';
import Search from './search';
import { connect, userSelector } from 'react-redux';
import { IMAGE_URL } from '../Constants/constants';
import SideBar from '../sidebar';


class Header extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            loginModalVisible: true,
            registerModalVisible: false,
            navbarisvisVisible: false,
            registerSubmit: false,
            loginSubmit: false,
            registerObject: {
                firstname: null,
                lastname: null,
                email: null,
                password: null,
                address: null
            },
            loginObject: {
                email: null,
                password: null
            },
            isAuthenticated: false,
            user: null,
            token: '',
            showSearch: false,
            notification: false,
        };

        this.openLoginModal = this.openLoginModal.bind(this);
        this.openRegisterModal = this.openRegisterModal.bind(this);
        this.openNavbar = this.openNavbar.bind(this);
        this.handleNav = this.handleNav.bind(this);
        this.showSearchbar = this.showSearchbar.bind(this);
        this.dropNotification = this.dropNotification.bind(this);
    }

    dropNotification = () => {
        this.setState({ notification: !this.state.notification })
    }

    handleNav = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    signup = async () => {
        await this.setState({ registerSubmit: true });
        if (!this.state.registerObject.firstname
            && !this.state.registerObject.lastname
            && !this.state.registerObject.email
            && !this.state.registerObject.password
            && !this.state.registerObject.address) {
            return false
        }

        axios.post('https://jplugbackend.herokuapp.com/api/auth/register', this.state.registerObject, (err, data) => {
            console.log(data);
        })
        console.log("signup now")
    };
    logout = () => {
        this.setState({ isAuthenticated: false, token: '', user: null })
    };

    twitterResponse = (response) => {
        const token = response.headers.get('x-auth-token');
        response.json().then(user => {
            if (token) {
                this.setState({ isAuthenticated: true, user, token });
            }
        });
    };

    googleResponse = (response) => {
        const tokenBlob = new Blob([JSON.stringify({ access_token: response.accessToken }, null, 2)], { type: 'application/json' });
        const options = {
            method: 'POST',
            body: { access_token: response.accessToken },
            //  mode: 'cors',
            //  cache: 'default'
        };
        fetch('https://jplug.herokuapp.com/api/auth/google', options).then(r => {
            const token = r.headers.get('x-auth-token');
            this.setState({ isAuthenticated: true });
            this.openLoginModal();
            r.json().then(user => {
                if (token) {
                    this.setState({ isAuthenticated: true, user, token })
                }
            });
        })

    };
    onFailure = (error) => {
        alert(error);
    }

    openLoginModal() {
        const loginModalVisible = !this.state.loginModalVisible;
        // this.setState({
        //   loginModalVisible
        // });
        window.location.replace('/login')
    }

    openNavbar() {
        const navbarisvisVisible = !this.state.navbarisvisVisible;
        this.setState({
            navbarisvisVisible: navbarisvisVisible
        });
    }


    responseFacebook(response) {
        const tokenBlob = new Blob([JSON.stringify({ access_token: response.accessToken }, null, 2)], { type: 'application/json' });
        const options = {
            method: 'POST',
            body: { access_token: response.accessToken },
            //  mode: 'cors',
            //  cache: 'default'
        };
        fetch('https://jplug.herokuapp.com/api/auth/facebook', options).then(r => {
            const token = r.headers.get('x-auth-token');
            this.setState({ isAuthenticated: true });
            this.openLoginModal();
            r.json().then(user => {
                if (token) {
                    // this.setState({isAuthenticated: true, user, token})
                }
            });
        })
    }

    RegisterChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        let obj = this.state.registerObject;
        obj[name] = value;
        this.setState({ registerObject: obj });
    }
    async openRegisterModal() {
        window.location.replace('/signup')
        const registerModalVisible = !this.state.registerModalVisible;
        // await this.setState({registerSubmit :false});

        // this.setState({
        //   registerModalVisible
        // });
    }

    showSearchbar = () => {
        this.setState({ showSearch: !this.state.showSearch })
    }


    render() {
        /*let loginStyles = this.state.loginModalVisible
        ? { display: "block"}
        : { display: "none" };
        let registerStyles = this.state.registerModalVisible
        ? { display: "block"}
        : { display: "none"};*/
        let loginStyles = { display: 'none' }
        let registerStyles = { display: 'none' }
        return (
            <React.Fragment>
                <div className="header_nav">
                    {this.state.showSearch ?
                        <CNavbar>
                            <button type="button" className="close closeBtn" aria-label="Close" onClick={this.showSearchbar}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <Search />
                        </CNavbar> :
                        <CNavbar className="customClas" expandable="sm" bg-dark="true" fixed="top">

                            <div className="jp-nav-side jp-nav-left">
                                <CImage inNavbar src="/images/search.svg" className="location-icon" alt="search" width="33" onClick={this.showSearchbar} />
                                <nav className="jp-nav-links">
                                    <Link className="jp-nav-link" to="/search">Dispensaries</Link>
                                    <Link className="jp-nav-link" to="/deals">Deals</Link>
                                    <Link className="jp-nav-link" to="/strain">Strains</Link>
                                </nav>
                            </div>
                            {(this.props.user.email) &&
                                <CDropdown inNav className="mobile-order-dropdown location-icon">
                                    <CDropdownToggle color="primary">
                                        <span className="order-icon">
                                            <i className="fa fa-shopping-cart"></i>
                                        </span>
                                    </CDropdownToggle>
                                    <CDropdownMenu>
                                        <CDropdownItem>Your Pre Orders</CDropdownItem>
                                        <CDropdownItem href="/cart">Go to cart</CDropdownItem>
                                        {(this.props.orders.length > 0) ? <React.Fragment>
                                            <CDropdownItem><CBadge color="primary"> {this.props.orders.filter(o => o._id === 'Pending')[0]?.count ?? 0} </CBadge> Pending</CDropdownItem>
                                            <CDropdownItem><CBadge color="warning"> {this.props.orders.filter(o => o._id === 'Processing')[0]?.count ?? 0} </CBadge> Processing</CDropdownItem>
                                            <CDropdownItem><CBadge color="success"> {this.props.orders.filter(o => o._id === 'Completed')[0]?.count ?? 0} </CBadge> Completed</CDropdownItem>
                                            <CDropdownItem><CBadge color="error"> {this.props.orders.filter(o => o._id === 'Cancelled')[0]?.count ?? 0} </CBadge> Cancelled</CDropdownItem>
                                            {/*<CDropdownItem><CBadge color="primary"> {this.props.orders.filter(o => o._id === 'OnTheWay')[0]?.count ?? 0} </CBadge> On The Way</CDropdownItem>*/}
                                        </React.Fragment>
                                            : <React.Fragment>
                                                <CDropdownItem><CBadge color="primary"> 0 </CBadge> Pending</CDropdownItem>
                                                <CDropdownItem><CBadge color="warning"> 0 </CBadge> Processing</CDropdownItem>
                                                <CDropdownItem><CBadge color="success"> 0 </CBadge> Completed</CDropdownItem>
                                                <CDropdownItem><CBadge color="error"> 0 </CBadge> Cancelled</CDropdownItem>
                                                <CDropdownItem><CBadge color="primary"> 0</CBadge> On The Way</CDropdownItem>
                                            </React.Fragment>
                                        }
                                    </CDropdownMenu>
                                </CDropdown>
                            }

                            <CNavbarBrand className="mobile-brand-icon" style={{ filter: "brightness(0) invert(1)" }}>
                                <img alt="logo" src="/images/11-n.png" />
                            </CNavbarBrand>
                            <CNavbarBrand className="mobile-brand">
                                <Link to="/">
                                    <img style={{ marginTop: "0px", filter: "grayscale(100%)" }} alt="logo" src="/images/white-logo.png" />
                                </Link>
                            </CNavbarBrand>
                            <div className="jp-nav-side jp-nav-right">
                                <nav className="jp-nav-links">
                                    <Link className="jp-nav-link" to="/blog">Blog</Link>
                                    <Link className="jp-nav-link" to="/news">News</Link>
                                    <Link className="jp-nav-link" to="/tour">Add Business</Link>
                                </nav>
                            <CCollapse show={this.state.isOpen} navbar>
                                {(this.props.user.email) ?
                                    <CNavbarNav className="profile_nav-drop">
                                        <CDropdown inNav className="order-dropdown">
                                            <CDropdownToggle color="primary">
                                                <span className="order-icon">
                                                    <i className="fa fa-shopping-cart"></i>
                                                </span>
                                            </CDropdownToggle>
                                            <CDropdownMenu>
                                                <CDropdownItem>Your Pre Orders</CDropdownItem>
                                                <CDropdownItem href="/cart">Go to cart</CDropdownItem>
                                                {(this.props.orders.length > 0) && <React.Fragment>
                                                    <CDropdownItem><CBadge color="primary"> {this.props.orders.filter(o => o._id === 'Pending')[0]?.count ?? 0} </CBadge> Pending</CDropdownItem>
                                                    <CDropdownItem><CBadge color="warning"> {this.props.orders.filter(o => o._id === 'Processing')[0]?.count ?? 0} </CBadge> Processing</CDropdownItem>
                                                    <CDropdownItem><CBadge color="success"> {this.props.orders.filter(o => o._id === 'Completed')[0]?.count ?? 0} </CBadge> Completed</CDropdownItem>
                                                    <CDropdownItem><CBadge color="error"> {this.props.orders.filter(o => o._id === 'Cancelled')[0]?.count ?? 0} </CBadge> Cancelled</CDropdownItem>
                                                    {/*<CDropdownItem><CBadge color="primary"> {this.props.orders.filter(o => o._id === 'OnTheWay')[0]?.count ?? 0} </CBadge> On The Way</CDropdownItem>*/}
                                                </React.Fragment>}
                                            </CDropdownMenu>
                                        </CDropdown>

                                        <CDropdown inNav>
                                            <CDropdownToggle color="primary">
                                                <span className="profile-pic">
                                                    {this.props.user.image ? <CImage src={IMAGE_URL + this.props.user.image} className="rounded-circle" /> : <CImage src="/images/smoke1.png" className="rounded-circle" />}</span>
                                                {this.props.user.username}
                                            </CDropdownToggle>
                                            <CDropdownMenu>
                                                {/*<CDropdownItem><Link to="/profile"><span><i className="fa fa-user" aria-hidden="true"></i></span>Your Profile</Link></CDropdownItem>*/}
                                                <CDropdownItem to="/profile"><span><i className="fa fa-user" aria-hidden="true"></i></span>Your Profile</CDropdownItem>
                                                {(this.props.user.role === 'SELLER') &&
                                                    <CDropdownItem to="/dashboard">
                                                        <span><i className="fa fa-user" aria-hidden="true"></i></span>Dashboard</CDropdownItem>}
                                                <CDropdownItem><span><i className="fa fa-envelope-o" aria-hidden="true"></i></span>Messages</CDropdownItem>
                                                <CDropdownItem to="/profile/pre-orders"><span><i className="fa fa-shopping-cart" aria-hidden="true"></i></span>Orders</CDropdownItem>
                                                <CDropdownItem onClick={() => { window.location.replace('/logout') }}><span><i className="fa fa-sign-out" aria-hidden="true"></i></span>Logout</CDropdownItem>
                                            </CDropdownMenu>
                                        </CDropdown>
                                        {/*<CButton className="pl-5 pr-5 pt-2 pb-2 text-white" onClick={() => {window.location.replace('/logout')}}>Logout</CButton>*/}
                                    </CNavbarNav> :
                                    <CNavbarNav>
                                        {!this.state.isOpen ?
                                            <>
                                                <CButton className="my-2 my-sm-0 text-white text-left" onClick={this.openLoginModal}>Login</CButton>
                                                <CButton color="success" className="pl-5 pr-5 pt-2 pb-2" onClick={() => { window.location.replace('/join') }}>Join</CButton>
                                            </> :
                                            <>
                                                <span className="loggedOut"><CImage src="/images/smoke1.png" className="rounded-circle" width="10%" /> Not LoggedIn</span>
                                                <CButton className="my-2 my-sm-0 text-white" onClick={() => { window.location.replace('/join') }}>Join</CButton>
                                                <CButton className="my-2 my-sm-0 text-white" onClick={this.openLoginModal}>Login</CButton>
                                                <CButton className="my-2 my-sm-0 text-white" onClick={() => { window.location.replace('/') }}>Contact Us</CButton>
                                                <CButton className="my-2 my-sm-0 text-white" onClick={() => { window.location.replace('/blog') }}>Blog</CButton>
                                                <CButton className="my-2 my-sm-0 text-white" onClick={() => { window.location.replace('/news') }}>News</CButton>
                                                <CButton className="my-2 my-sm-0 text-white" onClick={() => { window.location.replace('/tour') }}>Add Your Business</CButton>
                                            </>}
                                    </CNavbarNav>}
                            </CCollapse>
                            </div>
                            <SideBar pageWrapId={"page-wrap"} outerContainerId={"App"} homeBurgerState={false} />
                        </CNavbar>}
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({ user: state.user, orders: state.orders });

export default connect(mapStateToProps, null)(Header);
